// Central launch feature flags.
//
// Shared Transfers (browse/post/join scheduled trips) is not ready for the
// early launch, which leads with Bus Tickets and Private Transfers. The flow
// stays fully implemented but is hidden behind this flag so it can be turned
// on later without a code change.
const parseBooleanFlag = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') return defaultValue;
  const normalized = String(value).trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
};

export const FEATURES = {
  sharedTransfers: parseBooleanFlag(process.env.REACT_APP_ENABLE_SHARED_TRANSFERS, false),
  // Team ops panel (/team). Ships dark so the route can land before the ops
  // account is provisioned; flipping this on does not change who may read data,
  // which is decided server-side by TEAM_LOGIN_EMAIL.
  teamPanel: parseBooleanFlag(process.env.REACT_APP_ENABLE_TEAM_PANEL, false),
  // Destructive admin actions (e.g. wipe-all test data). Hidden by default;
  // server also requires ALLOW_ADMIN_CLEAR_DATA before any delete runs.
  destructiveAdminTools: parseBooleanFlag(process.env.REACT_APP_ENABLE_DESTRUCTIVE_ADMIN_TOOLS, false),
  // DPO mobile-money bus checkout (server + policy kill switches too). Despite the
  // "test" name this is ON in production as of Oct 2026: TZS / Airtel Money works;
  // KES / M-Pesa does not yet. Public copy (routes.js, guides.js) says the same.
  dpoTest: parseBooleanFlag(process.env.REACT_APP_ENABLE_DPO_TEST, false),
  // Restrict the cookie banner to UK/EU visitors instead of showing it to
  // everyone. Default false is the strict branch on purpose: unset, misspelled
  // or blank means every visitor is asked, so a configuration slip can never
  // silently stop people being asked for consent. Turning the gate ON is the
  // deliberate act. See src/components/CookieBanner.jsx.
  consentGeoGate: parseBooleanFlag(process.env.REACT_APP_CONSENT_GEO_GATE, false),
  // Attach window.supabase / window.dbHelpers for DevTools debug scripts.
  // Default false: production must not expose the data layer on window. Unset
  // or a typo means off. CRA bakes this at build time — a Vercel change needs
  // a redeploy. See src/config/supabase.js.
  windowGlobals: parseBooleanFlag(process.env.REACT_APP_ENABLE_WINDOW_GLOBALS, false),
};

export const isSharedTransfersEnabled = () => FEATURES.sharedTransfers;

export const isTeamPanelEnabled = () => FEATURES.teamPanel;

export const isDestructiveAdminToolsEnabled = () => FEATURES.destructiveAdminTools;

export const isDpoTestEnabled = () => FEATURES.dpoTest;

export const isConsentGeoGateEnabled = () => FEATURES.consentGeoGate;

export const isWindowGlobalsEnabled = () => FEATURES.windowGlobals;

export default FEATURES;
